import React from "react";
import "./notifications.css";
import help from "../../img/undraw_complete_task_re_44tb.svg";
import { Fade } from "react-awesome-reveal";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { GetuserNotificationAction } from "../../redux/actions/ManageAdminAction";
const NotificationsUser = () => {
  const dispatch = useDispatch();
  const notification = useSelector(
    (state) => state.ManageAdminR.getNotification
  );

  useEffect(() => {
    dispatch(GetuserNotificationAction(`PageSize=${50000}`));
  }, []);
  return (
    <div className="notifications">
      <div className="container rounded bg-white mt-5 mb-5">
        <div className="row">
          <div className="col-md-6 border-right">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-center">الأشعارات</h4>
              </div>
              <div className=" mt-3 noo">
                {notification &&
                notification.Data &&
                notification.Data.length >= 0
                  ? notification.Data.map((msg, idx) => {
                      return (
                        <div key={idx}>
                          {" "}
                          <div className="rectangle" key={idx}>
                            <div className="notification-text">
                              <i className="fa-solid fa-circle-info"></i>
                              <span>&nbsp;&nbsp; {msg.Message}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : "لا توجد أشعارات جديدة"}
              </div>
              {/* <div className="mt-5 text-center">
                  <button className=" profile-button" type="button">
                    إرسال
                  </button>
                </div> */}
            </div>
          </div>
          <div className="col-md-6">
            <Fade direction="left">
              <div className="p-3 py-5">
                <Fade direction="right">
                  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                    <img
                      className="mt-5"
                      width="150px"
                      src={help}
                      alt="avatar"
                    />
                  </div>
                </Fade>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsUser;
